import { Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { noop } from 'shell/utils/noop';
import { PecComunicazioneVO } from 'shell/models/pec';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { ManagementPecCrumbs } from 'civil-status/constants/breadcrumb';
import FormPec, { PecForm } from 'shell/components/shared/management-pec/pec-details/form';
import { transformPec } from 'shell/components/shared/management-pec/pec-details/utils/transformer-pec';

const PecDetailPage = (): React.ReactElement => {
  const params = useParams();

  const [pec, getPec] = useHttpFetch<HttpResponse<PecComunicazioneVO>, PecForm>(
    `${__ACT_API_URL__}/pec/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformPec,
    }
  );

  const navigate = useNavigate();

  const loadingPec = pec.isLoading || pec.pristine || pec.hasErrors;
  const pecData: PecForm = pec.data as PecForm;

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...ManagementPecCrumbs,
          {
            name: 'Dettaglio PEC',
          },
        ]}
      />
      {loadingPec ? null : (
        <FormPec
          title={`PEC - ${params.id} ${
            pecData.oldCode ? `rinvio della PEC ${pecData.oldCode}` : ''
          }`}
          onOk={noop}
          getPecDetail={getPec}
          onCancel={() => {
            navigate('/stato-civile/gestione-pec');
          }}
          idDetail
          initialValues={pecData}
        />
      )}
    </Fragment>
  );
};

PecDetailPage.displayName = 'Pec Detail page component';

export default PecDetailPage;
